import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";

let supabaseClient: SupabaseClient | null = null;

function redirectToSetPassword(session: {
  access_token: string;
  refresh_token: string;
}) {
  if (
    window.location.hash.includes("#/set-password") ||
    window.location.pathname === "/set-password"
  ) {
    return;
  }
  const params = new URLSearchParams({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
    type: "recovery",
  });
  window.location.replace(`${window.location.origin}/#/set-password?${params}`);
}

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(
      import.meta.env.VITE_SUPABASE_URL,
      import.meta.env.VITE_SB_PUBLISHABLE_KEY,
    );

    // If the recovery link lands on the Site URL (or PKCE exchanges the code)
    // before /auth-callback can rewrite the URL, supabase-js establishes a
    // session and clears the hash — which looks like a normal login. Force the
    // set-password page whenever Auth emits PASSWORD_RECOVERY.
    supabaseClient.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY" && session) {
        redirectToSetPassword(session);
      }
    });
  }
  return supabaseClient;
};
